<template>
<section class="spec-wrp">
  <span class="gray-bold">请选择您要进行组合铺货的SKU</span>
  <el-form class="list">
    <div class="filter-bar">
      <div class="filter-row">
        <span class="label">筛选:</span>
        <el-select v-model="filterSpec0Values" multiple collapse-tags clearable :placeholder="specNum === 1 ? '规格' : '规格1'" style="width: 136px" @change="applyFilters">
          <el-option v-for="v in optionSpec0List" :key="v" :value="v" :label="v" />
        </el-select>
        <template v-if="specNum > 1">
          <el-select v-model="filterSpec1Values" multiple collapse-tags clearable placeholder="规格2" style="width: 136px" @change="applyFilters">
            <el-option v-for="v in optionSpec1List" :key="v" :value="v" :label="v" />
          </el-select>
        </template>
        <el-checkbox v-model="quickRepeatOnly" @change="onQuickRepeat">重复SKU</el-checkbox>
        <el-checkbox v-model="quickUniqueKeepMain" @change="onQuickUnique">非重复SKU（保留主商品SKU）</el-checkbox>
      </div>
    </div>
    <div>
      <span class="tips"><i style="font-size: 14px" class="tips-icon el-icon-warning"></i>红色框提示代表有重复的SKU, 需处理</span>
    </div>
    <el-table
        ref="table"
        :data="displayTableData"
        border
        max-height="360px"
        style="width: 100%"
        tooltip-effect="dark"
        :stripe="false"
        @selection-change="handleSelectChange"
        :class="[`row-cell-height70`]"
         :cell-class-name="getCellClass"
        row-key="id"
    >
        <el-table-column align="center" type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column
            v-for="(col, cindex) in tableCols"
            :prop="col.prop"
            :key="cindex"
            :resizable="false"
            v-bind="col.attrs">
            <template slot-scope="scope">
                <template v-if="col.prop === 'imageUrl'">
                  <div class="prod-img" >
                    <span v-if="scope.row.baseItemId === mainBaseItemId" class="main-prod-tip">主商品</span>
                    <template>
                      <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" alt="error"/>
                      <div v-else class="no-pic">
                        <i class="el-icon-picture-outline"/>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else-if="col.prop === 'spec0'">
                  <el-form-item :error="specErrorMap[`spec0Error_${scope.row.id}`]">
                    <el-input width="100px" v-model="scope.row.spec0" @blur="onInput(scope.row, col.prop, scope)"></el-input>
                  </el-form-item>
                </template>
                <template v-else-if="col.prop === 'spec1' && scope.row.skuSpecifications[1]">
                   <el-form-item :error="specErrorMap[`spec1Error_${scope.row.id}`]">
                    <el-input width="100px" v-model="scope.row.spec1" @blur="onInput(scope.row, col.prop, scope)"></el-input>
                   </el-form-item>
                </template>
                <template v-else>{{ scope.row[col.prop] }}</template>
            </template>
        </el-table-column>
    </el-table>
  </el-form>
  <div class="select-sku">
    <span class="gray-bold">已选中SKU的颜色及规格</span>
    <div class="sku-wrp">
      <span>{{specNum === 1 ? '规格' : '规格1'}} ({{specList0.length}}) :</span>
      <div 
        class="item-wrp"
      >
        <el-button v-for="(item, idx) in specList0" :key="idx" type="default">{{item}}</el-button>
      </div>
    </div>
    <div class="sku-wrp" v-if="specNum > 1">
      <span>规格2 ({{specList1.length}}) :</span>
      <div 
        class="item-wrp"
      >
        <el-button v-for="(item, idx) in specList1" :key="idx" type="default">{{item}}</el-button>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import TableList from '@components/TableList.vue';
import {formatSpecList, getSpecNum} from '../utils';
import { getSkuList, getSupplierSkuList, getPieceItemSkuList } from '@/servers/prod/center';

export default {
  name: 'spec-list',
  components: {
    TableList
  },
  props: {
    rowsData: {
      type: Array,
      default() {
        return [];
      }
    },
    mainProd: {
      type: Number,
      default: 0
    },
    source: {
      type: String,
      default: ''
    }
  },
  inject: ['from', 'supplierCompanyId'],
  computed: {
    optionSpec0List() {
      const set = new Set();
      (this.tableData || []).forEach(r => { if (r && r.spec0) set.add(r.spec0) });
      return Array.from(set);
    },
    optionSpec1List() {
      const set = new Set();
      if (this.specNum > 1) {
        (this.tableData || []).forEach(r => { if (r && r.spec1) set.add(r.spec1) });
      }
      return Array.from(set);
    },
    specNames() {
      const names = [];
      if (this.oriSkus && this.oriSkus.length) {
        const first = this.oriSkus[0];
        if (first && first.skuSpecifications) {
          first.skuSpecifications.forEach((s, idx) => {
            if (s && s.name) names[idx] = s.name;
          })
        }
      }
      if (!names[0]) names[0] = this.specNum > 1 ? '规格1' : '规格';
      if (this.specNum > 1 && !names[1]) names[1] = '规格2';
      return names.filter(Boolean);
    },
    mainBaseItemId() {
      if (!this.rowsData.length) return '';
      return this.rowsData[this.mainProd] && this.rowsData[this.mainProd].baseItemId;
    },
    specList0() {
      let list = [];
      this.selectList.forEach(row => {
        if (row.spec0) {
          list.push(row.spec0);
        }
      });
      return [...new Set(list)];
    },
    specList1() {
      let list = [];
      this.selectList.forEach(row => {
        if (row.spec1) {
          list.push(row.spec1);
        }
      });
      return [...new Set(list)];
    },
    hasRepeatSku() {
      const repeatSpecArr = this.selectList.map(row => {
        return `${row.spec0 || ''}-${row.spec1 || ''}`;
      });
      const specArr = [...new Set(repeatSpecArr)];
      if (repeatSpecArr.length !== specArr.length) {
        return true;
      }
      return false;
    },
    tableCols() {
      const cols = [
        {prop: "imageUrl", attrs: {label: "商品图片", width: 80}, slot: true},
        {prop: "title", attrs: {label: "商品名称", 'show-overflow-tooltip': true}},
        {prop: "outerId", attrs: {label: "款式编码", width: 100}},
        {prop: "spec0", attrs: {label: "规格1", width: 126},slot: true},
        this.specNum > 1 ? {prop: "spec1", attrs: {label: "规格2", width: 126}, slot: true} : null,
        {prop: "skuOuterId", attrs: {label: "商品编码", width: 110}}
      ]
      return cols.filter(Boolean)
    },
    selectedMap() {
      const map = {}
      this.selectList.forEach(({id}) => map[id] = true);
      return map
    }
  },
  data() {
    return {
      tableData: [],
      displayTableData: [],
      specErrorMap: {},
      specNum: 0,
      selectList: [],
      oriSkus: [],
      filterSpec0Values: [],
      filterSpec1Values: [],
      quickRepeatOnly: false,
      quickUniqueKeepMain: false,
    }
  },
  watch: {
    oriSkus: {
      handler(v) {
        this.specNum = getSpecNum(v);
        this.tableData = formatSpecList(v, this.rowsData, this.specNum);
        this.displayTableData = this.tableData.slice(0);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    querySkuList() {
      const skuSpecPrefixSuffixList = this.rowsData.flatMap(row => row.skuSpecPrefixSuffixList || []);
      const baseItemIds = this.rowsData.map(row => row.baseItemId || row.itemId);
      // const fetchFunc = this.from === 'supplierShop' ? getSupplierSkuList : getSkuList;
      const params = { baseItemIds, skuSpecPrefixSuffixList, platformType: this.source };
      if (this.from === 'supplierShop') {
        params.supplierCompanyId = this.supplierCompanyId;
      }
      getPieceItemSkuList(params, this.source).then(list => {
        this.oriSkus = list.map(l => ({
          ...l,
          stockNum: l.stock,
          skuStock: l.stock,
          weight: this.source === '1688' ? (l.weight ? l.weight * 1000 : l.weight) : l.weight,
          skuSpecifications: (() => {
            try { return JSON.parse(l.skuSpecifications); } catch(e) { console.error(e); return []; }
          })()
        }));
        this.$nextTick(() => {
          this.$refs.table.toggleAllSelection();
        });
      });
    },
    onQuickRepeat(val) {
      if (val) {
        this.quickUniqueKeepMain = false;
      }
      this.applyFilters();
    },
    onQuickUnique(val) {
      if (val) {
        this.quickRepeatOnly = false;
      }
      this.applyFilters();
    },
    normalizedKey(row) {
      const a = (row.spec0 || '').trim();
      const b = (row.spec1 || '').trim();
      if (this.specNum > 1) {
        return [a, b].sort().join('@@');
      }
      return a;
    },
    applyFilters() {
      if (!this.$refs.table) return;
      const rows = this.tableData.slice(0);
      let filtered = rows;
      if (this.filterSpec0Values && this.filterSpec0Values.length) {
        filtered = filtered.filter(r => this.filterSpec0Values.includes(r.spec0))
      }
      if (this.specNum > 1 && this.filterSpec1Values && this.filterSpec1Values.length) {
        filtered = filtered.filter(r => this.filterSpec1Values.includes(r.spec1))
      }

      // quick filters
      if (this.quickRepeatOnly || this.quickUniqueKeepMain) {
        const groups = {};
        filtered.forEach(r => {
          const k = this.normalizedKey(r);
          if (!groups[k]) groups[k] = [];
          groups[k].push(r);
        })
        if (this.quickRepeatOnly) {
          filtered = Object.values(groups).flatMap(list => (list.length > 1 ? list : []))
        } else if (this.quickUniqueKeepMain) {
          const res = [];
          Object.values(groups).forEach(list => {
            if (list.length <= 1) {
              res.push(list[0])
            } else {
              const kept = list.find(r => r.baseItemId === this.mainBaseItemId) || list[0];
              res.push(kept)
            }
          })
          filtered = res;
        }
      }
      // 更新可见表格数据
      this.displayTableData = filtered;

      // 更新选中状态，仅对当前可见数据生效
      this.$nextTick(() => {
        if (!this.$refs.table) return;
        this.$refs.table.clearSelection();
        const idset = new Set(this.displayTableData.map(r => r.id));
        this.displayTableData.forEach(r => {
          this.$refs.table.toggleRowSelection(r, idset.has(r.id))
        })
      })
    },
    getSpecList() {
      return this.selectList.slice(0);
    },
    handleSelectChange(selection) {
      this.selectList = selection;
      this.validateSpecs()
    },
    getCellClass({row, column}) {
      if (column.property === 'spec0' || column.property === 'spec1') {
        return 'pdd-cell'
      }
      return '';
    },
    isSelect(row) {
      const item = this.selectList.find(sRow => sRow.id === row.id);
      return !!item;
    },
    validateRepeat(curRow) {
      const { spec0, spec1, id } = curRow;
      if (!spec0 && !spec1) return false;
      const text = `${spec0 || ''}-${spec1 || ''}`;
      let flag = false;
      this.tableData.forEach(row => {
        if (!this.selectedMap[row.id]) return;
        if (row.id === id) return;

        const fText = `${row.spec0 || ''}-${row.spec1 || ''}`;
        const rfText = `${row.spec1 || ''}-${row.spec0 || ''}`;

        if (fText === text || rfText === text) {
          flag = true;
        }
      })
      return flag;
    },
    clearErrorMsg() {
      this.tableData.forEach(item => {
        this.$set(this.specErrorMap, 'spec0Error_' + item.id, '');
        this.$set(this.specErrorMap, 'spec1Error_' + item.id, '');
      })
    },
    validateSpecs() {
      let flags = [];
      this.clearErrorMsg();
      this.tableData.forEach((row, idx) => {
        if (this.selectedMap[row.id]) {
          flags.push(this.validateSpec(row, 'spec0'));
          if (row.skuSpecifications[1]) {
            flags.push(this.validateSpec(row, 'spec1'));
          }
        }
      })
      let flag = flags.some(fl => fl === false)
      // if (flag) {
      //   this.$message.error('请正确填写规格列表');
      // }
      return flag;
  },
  validateSpec(row, field) {
    if (this.selectedMap[row.id]) {   
      let valid = true;
      let msg = '';
      if (!row[field]) {
        msg = '必填';
        this.$set(this.specErrorMap, field + 'Error_' + row.id, msg);
      } else {
        const isRepeat = this.validateRepeat(row);
        msg = isRepeat ? '有重复的SKU' : '';
        this.$set(this.specErrorMap, 'spec0Error_' + row.id, msg);
        this.$set(this.specErrorMap, 'spec1Error_' + row.id, msg);
      }
      if (msg) {
          valid = false;
      }
      return valid;
    }
  },
  getSpecNum() {
    return this.specNum;
  },
  onInput(row, field, scope) {
    if (field === 'spec1') {
      const skuSpecifications = row.skuSpecifications[1];
      if (skuSpecifications.isNewCreated) {
        const spec1 = (row.spec1 || '').trim();
        skuSpecifications.valueKey = spec1;
        const _skuid = row.skuSpecifications.map(s => s.valueKey).join('-');
        row._skuid = _skuid;
      }
    }
    this.validateSpecs()
  },
  },
  mounted() {
    this.querySkuList();
  },
}
</script>

<style lang="scss" scoped>
.spec-wrp {
  ::v-deep .el-table .cell {
    padding: 6px 10px;
  }
  .filter-bar {
    margin: 8px 0 12px;
    padding: 8px 12px;
    background: #fff;
    .filter-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
    .label { color: #606266; margin-right: 6px; }
  }
  .no-pic {
    font-size: 28px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ccc;
    width: 56px;
    height: 56px;
    border: 1px dashed #ccc;
    border-radius: 4px;
  }
}
.prod-img {
  position: relative;
  img {
    width: 56px;
    height: 56px;
  }
  .main-prod-tip{
    position: absolute;
    background: red;
    color: white;
    padding: 0px 10px;
    border-radius: 15px;
    transform: scale(0.83);
    font-weight: 500;
    left: -10px;
    top: -6px;
    height: 20px;
    line-height: 20px;
  }
}
.gray-bold {
  font-weight: 500;
  color: #424346;
}
.list {
  margin-top: 16px;
  position: relative;
  .tips {
    margin-bottom: 8px;
    float: right;
    color: red;
  }
}
.select-sku {
  margin-top: 15px;
  margin-bottom: 20px;
  .sku-wrp {
    margin-top: 10px;
    &:before, &:after {
      display: table;
      content: "";
    }
    &:after {
      clear: both;
    }
    &>span {
      width: 8%;
      line-height: 24px;
      float: left;
    }
    .item-wrp {
      margin-left: 8%;
      ::v-deep .el-button {
        padding: 5px 5px;
        height: 22px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
